import { z } from "zod";
import type { MerchantDTO } from "@/api/types/merchants.types";

export enum BudgetTimePeriod {
	ALL_TIME = "ALL_TIME",
	MONTHLY = "MONTHLY",
	QUARTERLY = "QUARTERLY",
	ANNUALLY = "ANNUALLY",
}

export const CreateClientSchema = (t: any) =>
	z.object({
		clientName: z.string().min(1, t("clientName.validation")),
		clientLogo: z.any().optional().nullable(),
		budgetAmount: z
			.string()
			.min(1, t("budgetAmount.validation"))
			.refine(
				(val) => !isNaN(parseFloat(val)) && parseFloat(val) > 0,
				t("budgetAmount.validation"),
			),
		budgetTimePeriod: z.nativeEnum(BudgetTimePeriod, {
			errorMap: () => ({ message: t("budgetTimePeriod.validation") }),
		}),
		merchants: z.array(z.any()).default([]),
	});

export type CreateClientSchemaType = ReturnType<typeof CreateClientSchema>;

export const createClientDefaultValues = {
	clientName: "",
	clientLogo: null as File | null,
	budgetAmount: "",
	budgetTimePeriod: undefined as BudgetTimePeriod | undefined,
	merchants: [] as MerchantDTO[],
};
